import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

import { Section, Inner } from './shared';
import { media } from '../../styles/style-utils';
import { type } from '../../styles/typography';

const Wrapper = styled(Section)`
  padding-top: 64px;
  padding-bottom: 72px;
  background-color: var(--b-lavender-grey);
  color: var(--b-black);

  ${media.medium`
    padding-top: 88px;
    padding-bottom: 96px;
  `};
`;

const Columns = styled(Inner)`
  display: grid;
  grid-template-columns: 1fr;
  gap: 40px;

  ${media.medium`
    grid-template-columns: 1fr 1fr;
    gap: 10px;
  `};

  h2 {
    ${type('headline', 'medium', { emphasis: true })};
    margin: 0;
    padding: 0;
    color: var(--b-black);
  }
`;

const Copy = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
  max-width: 577px;

  h3 {
    ${type('title', 'medium', { emphasis: true, uppercase: true })};
    margin: 0;
    padding: 0;
    color: rgba(0, 0, 0, 0.91);
  }

  p {
    ${type('body', 'large')};
    margin: 0;
    color: rgba(0, 0, 0, 0.72);

    + p {
      margin-top: 1.3em;
    }
  }
`;

const Masterpiece = () => (
  <Wrapper>
    <Columns>
      <h2>
        <FormattedMessage
          id="home.masterpiece.headline"
          defaultMessage="There is more than{br}one way to hear a {br}masterpiece."
          values={{ br: <br /> }}
        />
      </h2>
      <Copy>
        <h3>
          <FormattedMessage
            id="home.masterpiece.subtitle"
            defaultMessage="A work is more than a track"
          />
        </h3>
        <div>
          <p>
            <FormattedMessage
              id="home.masterpiece.p1"
              defaultMessage="Every recording tells you more than a track title can. The work, its movements, the composer, conductor, orchestra, soloists and interpretation all belong together. IDAGIO was designed to preserve those connections."
            />
          </p>
          <p>
            <FormattedMessage
              id="home.masterpiece.p2"
              defaultMessage="Return to a favourite interpretation or wander into an unfamiliar one. Everything you need to go deeper is there, without ever getting between you and the music."
            />
          </p>
        </div>
      </Copy>
    </Columns>
  </Wrapper>
);

export default Masterpiece;



// WEBPACK FOOTER //
// /tmp/build_2cb81483/src/components/home/Masterpiece.js